// extracted by mini-css-extract-plugin
export default {"menuIconButton":"workflow-menu-module__menuIconButton--aROA9","actionMenuOverlay":"workflow-menu-module__actionMenuOverlay--ZCpvj"};